import { render, staticRenderFns } from "./AddSpecificData.vue?vue&type=template&id=1c590cf8"
import script from "./AddSpecificData.vue?vue&type=script&lang=js"
export * from "./AddSpecificData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports